import { Alert, Box, Button, Icon, IconButton, Modal, Typography } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import React from "react";
import { usePathContext } from "./PathInfo";
import { useTreeModifyContext } from "./TreeDataContext";
import { isPropertyMandatory } from "./Helpers";

interface RemovePropertyButtonProps {
  propName: string;
}

export function RemovePropertyButton(props: RemovePropertyButtonProps) {
  const { path } = usePathContext();
  const { removeAtPath } = useTreeModifyContext();

  const [isModalOpen, setIsModalOpen] = React.useState(false);

  function handleOpenModal() {
    setIsModalOpen(true);
  }

  function handleConfirmRemovePrompt() {
    setIsModalOpen(false);
    removeAtPath(path);
    const newPath = path.slice();
    newPath.splice(-1, 1, "__cond_" + path.at(-1));
    removeAtPath(newPath);
  }

  const propertyName = path.at(-1);
  const gamePieceName = path.at(-2);
  if (isPropertyMandatory(props.propName)) {
    return (
      <IconButton disabled={true}>
        <Icon />
      </IconButton>
    );
  }

  return (
    <>
      {isModalOpen && (
        <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
          <Box className={"dynamic-modal"}>
            <Box sx={{ margin: "10px" }}>
              <Box className="vertical-flex">
                <Typography variant={"h5"}>Confirm deletion? </Typography>
                <Typography>
                  Are you sure you want to remove "{propertyName}" from "{gamePieceName}"?
                </Typography>
                <Alert severity="warning">This will also remove all conditional cases.</Alert>
                <Box className="horizontal-flex">
                  <Box className={"flex-filler"}></Box>
                  <Button variant={"contained"} color={"success"} onClick={() => setIsModalOpen(false)}>
                    Cancel
                  </Button>
                  <Button variant={"contained"} color={"error"} onClick={() => handleConfirmRemovePrompt()}>
                    Remove
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Modal>
      )}

      <IconButton color={"error"} onClick={(_) => handleOpenModal()}>
        <DeleteIcon />
      </IconButton>
    </>
  );
}
